import React, { Component } from 'react';
import { Container, Row, Col, Label, Form, Badge, Button } from 'reactstrap';
import RequireForAccess, { ReactAccessProvider } from 'react-access';
import AxiosInstance from '../AxiosInstance/AxiosInstance';

class ToDoListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false
    };
  }

  renderTaskSection() {
    const { task, isCompleted } = this.props;

    const taskStyle = {
      color: isCompleted ? '#ea6b5d' : '#d9534f',
      cursor: 'pointer',
    };

    if (this.state.isEditing) {
      return (
        <Label >
          < Form onSubmit={this.onSaveClick.bind(this)} >
            <input className="form-control input-sm" defaultValue={task} ref="editInput" type="text" />
          </Form>
        </Label>
      )
    }

    return (
      <Label style={taskStyle} onClick={this.props.toggleTask.bind(this, task)}>
        {task}
      </Label>
    )
  }

  renderStateSection() {
    const { isCompleted } = this.props;

    if (isCompleted) {
      return (
        <Badge color="success" pill>Complete</Badge>
      )
    }

    return (
      <Badge color="danger" pill>Incomplete</Badge>
    )
  }

  renderActionSection() {
    if (this.state.isEditing) {
      return (
        <div>
          <Button outline color="success" className="fa fa-check mx-2" size="sm" onClick={this.onSaveClick.bind(this)}></Button>

          <Button outline color="danger" className="fa fa-ban mx-2" size="sm" onClick={this.onCancelClick.bind(this)}></Button>
        </div>
      )
    }

    return (
      <ReactAccessProvider permissions={this.state.functionAccess}>
        <RequireForAccess
          permissions={['btnEdit']}
          //invalidAccessComponent={<span>You do not have admin access!</span>}
        >
          <Button outline color="info btn-icon" className="cui-pencil mx-2" size="sm" onClick={this.onEditClick.bind(this)}></Button>
        </RequireForAccess>
        <RequireForAccess
          permissions={['btnDelete']}
          //invalidAccessComponent={<span>You do not have admin access!</span>}
        >
          <Button outline color="danger btn-icon" className="icon-trash icons " size="sm" onClick={this.props.deleteTask.bind(this, this.props.task)}></Button>
        </RequireForAccess>
      </ReactAccessProvider>
    )
  }

  render() {
    return (
      <Container>
        <Row className="row-todo">
          <Col md="6" xs="5" className="col-todo">
            {this.renderTaskSection()}
          </Col>
          <Col md="2" className="text-right col-todo " xs="2" >
            {this.renderStateSection()}
          </Col>
          <Col md="4" className="text-right col-todo " xs="5" >
            {this.renderActionSection()}
          </Col>
        </Row>
      </Container>
    )
  }

  componentDidUpdate() {
    if (this.state.isEditing) {
      this.refs.editInput.focus();
    }
  }

  onEditClick() {
    this.setState({ isEditing: true });
  }

  onCancelClick() {
    this.setState({ isEditing: false });
  }

  onSaveClick(event) {
    event.preventDefault();

    const oldTask = this.props.task;
    const newTask = this.refs.editInput.value;
    this.props.saveTask(oldTask, newTask);
    this.setState({ isEditing: false });
  }

  componentDidMount() {
    this.loadFunctionAccess();
  }

  loadFunctionAccess() {
    var self = this;

    AxiosInstance({
      method: 'Post',
      url: '/tbSYS_b_FunctionAccess/usp_tbSYS_b_FunctionAccess_CheckAccessRight',
      errorHandle: true,
      data: {
        sScreenCode: 'CRSFRM010'
      }
    })
    .then(response => {
      var data = response.data.map(a => a.functionCode);
      self.setState({
        functionAccess: data
      });
    })
    .catch(function (error) {
    });
  }

}

export default ToDoListItem;

